<template>
  <div class="radio" :class="{ 'radio--block': props.variation === 'block' }">
    <input
      :id="props.id"
      v-bind="$attrs"
      :name="props.name"
      :value="props.value"
      type="radio"
      :checked="isChecked"
      @change="onChange()"
    />
    <label :for="props.id">
      <slot></slot>
    </label>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps<{
  id: string;
  name: string;
  value: unknown;
  modelValue: unknown;
  compareBy?: string;
  variation?: "block";
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: unknown): void;
}>();

const isChecked = computed(() => {
  if (props.compareBy) {
    return props.modelValue?.[props.compareBy] === props.value?.[props.compareBy];
  }

  return props.modelValue === props.value;
});

const onChange = () => {
  emit("update:modelValue", props.value);
};
</script>
